import { createSelector } from 'reselect';
import { TimeUnit } from '@mews/enums';
import { getStringProp, getStringArrayProp, getStringOrUndefinedProp } from '@mews/fp';
import { FeatureFlag } from '@mews-commander/enums';
import { getFeatureFlagService, getResolveRoute } from '@mews-commander/legacy-app-instance';
import { getCurrentEnterpriseUserPreferredServiceId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import parentSelector from '../../selector';
import { DENSITY, DENSITY_PERCENTAGE, TIMELINE_VIEW_NAME } from '../constants';
import { getTimelineUrl } from '../routes';

const getTimelineView = createSelector(parentSelector, (state) => state[TIMELINE_VIEW_NAME]);

export const getSelectedDensity = createSelector(getTimelineView, (state) => {
    if (getFeatureFlagService().hasFlag(FeatureFlag.percentageDensityValuesEnabled)) {
        return state.selectedDensityPercentage ?? DENSITY_PERCENTAGE['100'];
    }
    if (
        getFeatureFlagService().hasFlag(FeatureFlag.verticalLazyLoadingTimelineEnabled) &&
        state.selectedTimeUnit === TimeUnit.Month &&
        state.selectedDensity === DENSITY.DENSE
    ) {
        return DENSITY.COMPACT;
    }
    return state.selectedDensity ?? DENSITY.SPACIOUS;
});
export const getSelectedTimeUnit = createSelector(getTimelineView, (state) => state.selectedTimeUnit || TimeUnit.Day);

export const getCurrentEnterpriseTimelineUrl = createSelector(
    () => getResolveRoute(),
    getStringProp('reservationId'),
    getStringProp('serviceId'),
    getCurrentEnterpriseUserPreferredServiceId,
    getStringProp('period'),
    getStringArrayProp('floorNumbers'),
    getStringArrayProp('resourceFeatureIds'),
    getStringArrayProp('resourceCategoryIds'),
    getStringOrUndefinedProp('dateTime'),
    (
        resolveUrl,
        reservationId,
        serviceId,
        enterpriseServiceId,
        period,
        floorNumbers,
        resourceFeatureIds,
        resourceCategoryIds,
        dateTime
    ) =>
        getTimelineUrl(resolveUrl)({
            reservationId,
            serviceId: serviceId || (enterpriseServiceId as string),
            period,
            floorNumbers,
            resourceFeatureIds,
            resourceCategoryIds,
            dateTime,
        })
);
